import "vite/modulepreload-polyfill";
import "./lib.mam.mjs";
import "./main.mam.scss";
import Masonry from "masonry-layout";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import GaugeController from "./js/libs/controller.gauge";
import { tns } from "tiny-slider/src/tiny-slider";
import Alpine from "alpinejs";
// import Alpine from "@alpinejs/csp";
import intersect from "@alpinejs/intersect";
import persist from "@alpinejs/persist";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";
import tooltip from "./js/libs/alpine-tooltip";
import resize from "@alpinejs/resize";
import validate from "@colinaut/alpinejs-plugin-simple-validate";
import { load } from "recaptcha-v3";
import Papa from "papaparse";

// ALPINE PLUGINS
Alpine.plugin(intersect);
Alpine.plugin(persist);
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(tooltip);
Alpine.plugin(resize);
Alpine.plugin(validate);

const mamModules = ["gridslider"];

const commonModules = [
	"accordion",
	"carousel",
	"calendar",
	"chart",
	"contact",
	"contentListing",
	"dropdown",
	"form",
	"footer",
	"header",
	"html",
	"mobileMenu",
	"masonry",
	"richtextArea",
	"search",
	"searchAutocomplete",
	"searchFacets",
	"subNav",
	"tabber",
	"video",
	"advanceForm",
	"iframe",
	"filter",
	"filterFacets",
];

const importModules = [
	...commonModules.map((item) =>
		import(
			/* webpackChunkName: "[request]" */
			/* webpackMode: "lazy" */
			`./js/tiw/${item}.js`
		)
	),
	...mamModules.map((item) =>
		import(
			/* webpackChunkName: "[request]" */
			/* webpackMode: "lazy" */
			`./js/mam/${item}.js`
		)
	),
];

(function () {
	Alpine.store("app", {
		editMode: false,
		contextPath: "",
		restBase: "",
		language: "",
		munchkinKey: "",
		recaptchaKey: "",
		originalBrowserURL: "",
		init() {
			const { editMode, contextPath, restBase, language, munchkinKey, recaptchaKey, originalBrowserURL } = window.params || {};
			this.editMode = editMode;
			this.contextPath = contextPath;
			this.restBase = restBase;
			this.language = language;
			this.munchkinKey = munchkinKey;
			this.recaptchaKey = recaptchaKey;
			this.originalBrowserURL = originalBrowserURL;
		},
		screens: {
			sm: 600,
			md: 768,
			lg: 992,
			xl: 1200,
			"2xl": 1600,
		},
	});

	const allModules = [...commonModules, ...mamModules];
	Promise.all(importModules)
		.then((values) => {
			for (let i = 0; i < values.length; i++) {
				Alpine.data(allModules[i], values[i].default);
			}
			return values;
		})
		.then((values) => {
			Alpine.start();
			setTimeout(() => {
				const searchModule = values[allModules.indexOf("search")];
				if (searchModule?.initSearch) searchModule.initSearch();
			}, 100);
		});

	Chart.register(ChartDataLabels);
	Chart.register(GaugeController);

	this.Alpine = Alpine;
	this.Masonry = Masonry;
	this.tns = tns;
	this.Chart = Chart;
	this.Papa = Papa;
	this.recaptchaLoad = load;
}).call(window);
